import React, { useEffect, useState } from "react";
import { API, UPLOADS } from "./../../config/api";
export default function Pendingdesigner() {
  const [designers, setDesigners] = useState([]);
  const [selectedDesigner, setSelectedDesigner] = useState(null);
  const [showModal, setShowModal] = useState(false);

  // Fetch Pending Designers
  useEffect(() => {
    fetchDesigners();
  }, []);

  const fetchDesigners = async () => {
    // UPDATED: Now uses the action to filter pending designers
    const res = await fetch(API.LIST_PENDING);
    const data = await res.json();
    setDesigners(data);
  };

  const handleView = (designer) => {
    setSelectedDesigner(designer);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  // Accept Designer
  const handleAccept = async () => {
    try {
      const formData = new FormData();
      formData.append("id", selectedDesigner.id);
      formData.append("status", "active");

      // UPDATED: Points to unified api.php
      await fetch(API.UPDATE_DESIGNER_STATUS, {
        method: "POST",
        body: formData,
      });

      fetchDesigners();
      setShowModal(false);
    } catch (error) {
      console.error("Accept Error:", error);
    }
  };

  // Reject (Delete) Designer
  const handleReject = async () => {
    const confirmDelete = window.confirm(
      "Are you sure? Rejecting this designer will permanently delete them from the database.",
    );

    if (!confirmDelete) return;

    try {
      const formData = new FormData();
      formData.append("id", selectedDesigner.id);

      // UPDATED: Points to unified api.php
      const res = await fetch(API.DELETE_DESIGNER, {
        method: "POST",
        body: formData,
      });

      const data = await res.json();
      alert(data.message);

      fetchDesigners();
      setShowModal(false);
    } catch (error) {
      console.error("Delete Error:", error);
    }
  };

  return (
    <div className="dashboard-content">
      <h2 className="machine-title">Pending Designer Requests</h2>

      <div className="table-responsive">
        <table className="machine-table">
          <thead>
            <tr>
              <th>#</th>
              <th>User Id</th>
              <th>Date</th>
              <th>Name</th>
              <th>Email</th>
              <th>Mobile No</th>
              <th>Experience</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {designers.map((item, index) => (
              <tr key={item.id}>
                <td>{index + 1}</td>
                <td data-label="user id">{item.user_id}</td>
                <td>
                  {" "}
                  <div className="fw-bold">
                    {new Date(item.created_at).toLocaleDateString()}
                  </div>
                  <div className="text-muted small">
                    {new Date(item.created_at).toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </div>
                </td>
                <td>{item.name}</td>
                <td>{item.email}</td>
                <td>{item.phone}</td>
                <td>{item.experience}</td>
                <td>
                  <span className="status-pending">{item.status}</span>
                </td>
                <td>
                  <button className="view-btn" onClick={() => handleView(item)}>
                    View
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Modal */}
      {showModal && selectedDesigner && (
        <div className="modal-overlay">
          {" "}
          {/* Reset to unified background class */}
          <div className="modal-box" style={{ maxWidth: "700px" }}>
            {" "}
            {/* Reset to unified box class */}
            <h4 className="mb-3 border-bottom pb-2">Designer Details</h4>
            <div className="row">
              {/* Left Side: Profile Image */}
              <div className="col-md-4 text-center mb-3">
                <img
                  src={`${UPLOADS.DESIGNER_IMAGE}${selectedDesigner.profile}`}
                  alt={selectedDesigner.name}
                  className="img-fluid rounded shadow-sm border"
                  style={{
                    width: "100%",
                    maxHeight: "220px",
                    objectFit: "cover",
                  }}
                />
                <div className="mt-3">
                  <span
                    className={`badge ${selectedDesigner.status === "active" ? "bg-success" : "bg-warning text-dark"}`}
                  >
                    {selectedDesigner.status}
                  </span>
                </div>
              </div>

              {/* Right Side: Details Grid */}
              <div className="col-md-8">
                <div className="row g-3">
                  <div className="col-6">
                    <small className="text-muted d-block">Name</small>
                    <strong>{selectedDesigner.name}</strong>
                  </div>
                  <div className="col-6">
                    <small className="text-muted d-block">Experience</small>
                    <strong>{selectedDesigner.experience}</strong>
                  </div>

                  <div className="col-6">
                    <small className="text-muted d-block">Mobile No</small>
                    <strong>{selectedDesigner.phone}</strong>
                  </div>
                  <div className="col-6">
                    <small className="text-muted d-block">
                      Expected Salary
                    </small>
                    <strong>₹{selectedDesigner.expected_salary}</strong>
                  </div>
                  <div className="col-6">
                    <small className="text-muted d-block">Skills</small>
                    <p className="mb-0">{selectedDesigner.skills}</p>
                  </div>
                  <div className="col-6">
                    <small className="text-muted d-block">Location</small>
                    <p className="mb-0">{selectedDesigner.location}</p>
                  </div>
                  <div className="col-12">
                    <small className="text-muted d-block">Email</small>
                    <strong>{selectedDesigner.email}</strong>
                  </div>
                  <div className="col-12">
                    <small className="text-muted d-block">Description</small>
                    <p className="mb-0">{selectedDesigner.description}</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-4 pt-3 border-top d-flex justify-content-end gap-2">
              {selectedDesigner.status !== "active" && (
                <button className="btn btn-success px-4" onClick={handleAccept}>
                  Accept
                </button>
              )}
              <button className="btn btn-danger px-4" onClick={handleReject}>
                Reject & Delete
              </button>
              <button className="btn btn-secondary px-4" onClick={handleClose}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
